import React from 'react';

const ClientSiteContext = React.createContext('client_site_context');

export default ClientSiteContext;
